<template>
  <form @submit.prevent>
    <CModal
        :title.sync="title"
        color="info"
        :closeOnBackdrop ="false"
        :show.sync="show"
        size="lg">
        <CAlert color="primary" v-if="photoKids == false">
            You can upload a photo from computer or take a picture
          </CAlert>
          <b-form-file v-model="form.file" id="filePhoto" plain></b-form-file>
          <hr>
          <CButton v-if="photoKids == false" block @click="showCamera" color="warning"> Take A Photo</CButton>
          <div v-if="photoKids">
            <CAlert color="primary">
            You can take a photo by clicking the snap button
          </CAlert>
          <CRow>
            <CCol sm="6">
            </CCol>
            <CCol>
              <b>PREVIEW</b>
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="6">
              <video ref="videoElement" class="sizeVideo"  autoplay></video>
            </CCol>
            <CCol>
              <img v-if="photo" class="sizePhoto" :src="photo" alt="Captured Photo">
            </CCol>
          </CRow>
          <canvas ref="canvasElement"  hidden ></canvas>
          <CButton block @click="takePhoto"  color="warning"> <b-icon class="mr-2 mb-1" icon="camera" font-scale="1.2"></b-icon>Snap</CButton>
          </div>
          
        <template #footer>
        <CButton @click="close" color="danger">Cancel</CButton>

        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="upload()"  variant="outline" color="info">Upload</CButton>
      </template>
    </CModal>
  </form>
  
</template>

<script>
import moment from 'moment';

import EventBus from '@/eventBus';

import ikid from '@/services/ikid'
import files from '@/services/files'

export default {
name: 'keperluanmodal',

  data () {
    return {
      show: false,
      photoKids: false,
      title: 'Default Title',
      mode: '',
      photo: null,
      form:{
        id: '',
        uuid: '',
        file: '',
        belongs_to: '',
      },
    }
  },
  mounted(){
   
  },
  created () {
    var self = this;
    EventBus.$on('OPEN_MODAL_IKID_PHOTO', (params) => {
      if(params.data){
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.belongs_to = params.data
      }else{

      }
    });
  },

  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
      this.photoKids = false;
      this.clearForm()
    },

    clearForm(){
      this.photo = ''
      this.form ={
        id: '',
        uuid: '',
        file: '',
        belongs_to: '',
      }
    },

    showCamera(){
      this.photoKids = true,
      this.initializeCamera();
    },
    
    upload(){
        let formData = new FormData();
        formData.append('file', this.form.file);
        formData.append('belongs_to', this.form.belongs_to);
        this.show = false;
        files.uploadIkidPhoto(formData)
        .then(res => {
            EventBus.$emit('TABLE_UPDATE', true)
            var params = {title: 'Success', mode:'success', data:res.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
            this.clearForm()
        }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
    },
    initializeCamera() {
      navigator.mediaDevices.getUserMedia({ video: true })
        .then(stream => {
          this.$refs.videoElement.srcObject = stream;
        })
        .catch(error => {
          console.error('Error accessing camera:', error);
        });
    },
    takePhoto() {
      const videoElement = this.$refs.videoElement;
      const canvasElement = this.$refs.canvasElement;

      // Set the canvas dimensions to match the video element
      canvasElement.width = videoElement.videoWidth;
      canvasElement.height = videoElement.videoHeight;

      // Draw the current frame from the video on the canvas
      canvasElement.getContext('2d').drawImage(videoElement, 0, 0, canvasElement.width, canvasElement.height);

      function dataURItoBlob(dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString;
      if (dataURI.split(',')[0].indexOf('base64') >= 0)
          byteString = atob(dataURI.split(',')[1]);
      else
          byteString = unescape(dataURI.split(',')[1]);
      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], {type:mimeString});
      }

      // Convert the canvas image data to a data URL
      const blob = canvasElement.toDataURL('image/png')
      const binary = dataURItoBlob(blob)
      this.photo = blob
      const myFileName = "KidsPhoto.png";
      const myFileType = "image/png";
      const file = new File([binary], myFileName,{ type: myFileType })
      this.form.file = file
      
    },
  }
}
</script>

<style>
.center {
    display: flex;
    align-items: center;
    justify-content: center;
}

.sizePhoto {
  height: 273px  !important ;
  width: 360px !important ;
  position: relative;
  top: 0.8em;
}
.sizeVideo {
  height: 300px  !important ;
  width: 360px !important ;
  position: relative;
}

</style>